
export const apiAddress =  process.env.REACT_APP_API_URL;

export const msTeamsProvisionerApp = {
    id: 'd24383d9-d81d-4e02-a55c-94b36ccaef84',
    manageCenterTabId: 'manageCenter-tab',
    createSiteTabId: 'manageCenter-tab'
};

export const msTeamsSpApp = {
    id: '7b49c510-80cb-11ea-a297-a37306eccdef',
    trainingsTabId: 'trainings-tab'
};



// WEBPACK FOOTER //
// ./src/GlobalConst/globalConst.js